<template>
    <custom-table
        :title="$t('pages.customer.title')"
        :subTitle="$t('pages.customer.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        selectableRows
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        changeUrlPage
        filterComponentName="CustomerFilter"
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange"
    >
        <template v-slot:customer="{ row: record }">
            <span class="fw-bolder">{{ record.firstname + ' ' + record.lastname }}</span>
        </template>
        <template v-slot:mobilePhone="{ row: record }">
            <a :href="'tel:' + record.mobile_phone" class="text-gray-600 text-hover-primary mb-1" v-if="record.mobile_phone">
                {{ formatPhonePretty(record.mobile_phone) }}
            </a>
            <span v-else>-</span>
        </template>
        <template v-slot:email="{ row: record }">
            <a :href="'mailto:' + record.email" class="text-gray-600 text-hover-primary mb-1" v-if="record.email">
                {{ record.email }}
            </a>
            <span v-else>-</span>
        </template>

        <template v-slot:active="{ row: record }">
            <span :class="record.active ? 'badge-light-success': 'badge-light-danger'" class="badge">{{ record.active ? $t('common.active') : $t('common.passive') }}</span>
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('pages.module.VEHICLE_WORK_ORDER.title')" placement="top" v-if="hasModule(record, 'VEHICLE_WORK_ORDER')">
                    <router-link :to="'/module/vehicle-work-order/list?company_customer_id=' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                         <span class="svg-icon svg-icon-3">
                             <inline-svg src="/media/icons/duotune/art/art002.svg"/>
                         </span>
                    </router-link>
                </el-tooltip>
                <el-tooltip :content="$t('common.transaction.title')" placement="top">
                    <router-link :to="'/customer/transaction/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                         <span class="svg-icon svg-icon-3">
                             <inline-svg src="/media/icons/duotune/finance/fin010.svg"/>
                         </span>
                    </router-link>
                </el-tooltip>
                <el-tooltip :content="$t('common.detail')" placement="top">
                    <router-link :to="'/customer/detail/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                         <span class="svg-icon svg-icon-3">
                             <inline-svg src="/media/icons/duotune/general/gen004.svg"/>
                         </span>
                    </router-link>
                </el-tooltip>
                <el-tooltip :content="$t('common.edit')" placement="top">
                    <router-link :to="'/customer/save/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                         <span class="svg-icon svg-icon-3">
                             <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                         </span>
                    </router-link>
                </el-tooltip>
                <el-tooltip :content="$t('common.delete')" placement="top">
                    <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteRecord([record.id])">
                        <template #reference>
                            <a class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                                <span class="svg-icon svg-icon-3">
                                    <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                                </span>
                            </a>
                        </template>
                    </el-popconfirm>
                </el-tooltip>
            </div>
        </template>
    </custom-table>
</template>

<script>
import CustomTable from "@/components/custom-table";
import { formatPhonePretty } from "@/core/services/Helper";

export default {
    name: "customer",
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.customer.cols.id"),
                    key: "id",
                    class: ''
                },
                {
                    name: this.$t("pages.customer.cols.customer"),
                    scopedSlots: {customRender: "customer"}
                },
                {
                    name: this.$t("pages.customer.cols.mobilePhone"),
                    scopedSlots: {customRender: "mobilePhone"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            rules: {},
            selectedRowKeys: [],
            filterParameters: {},
            exportLoading: false
        }
    },
    computed: {
        table() {
            return this.$store.state.customer.table;
        },
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.customerList"), []);

        this.filterParameters = {
            sort: 'created_at:desc'
        };

        this.refreshTable();
    },
    methods: {
        formatPhonePretty,
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    //this.newUser();
                    this.$router.push({
                        path: "/customer/save"
                    });
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        refreshTable() {
            this.$store.dispatch('customer/get', {
                page: {
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
            });
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = Object.assign({
                sort: 'created_at:desc',
            }, filterData);

            this.$store.dispatch("customer/get", {
                page: pagination,
                filterData: this.filterParameters
            });
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        },
        deleteRecord(id) {
            this.$store.dispatch("customer/delete", {
                id: id
            }).then((successDeleted) => {
                this.refreshTable();
            });
        },
        hasModule(record, moduleCode) {
            if (!record?.customer_modules?.length) {
                return false
            }

            return record.customer_modules.some(
                item => item.module?.code === moduleCode
            )
        }
    }
}
</script>

<style scoped>

</style>